window.addEventListener('DOMContentLoaded', () => {
  /*navbar*/
  const navHamburger = document.getElementById('nav-hamburger')!;
  const navbarHamburger = document.getElementById('navbar-hamburger')!;
  const navBorder = document.querySelectorAll('.navbar-borderline')!;
  const suggestionBox = document.getElementById('search-suggestion-box')!;
  navHamburger.addEventListener('click', function () {
    navHamburger.getElementsByClassName('hamburger')[0].classList.toggle('is-active');
    navBorder[0].classList.toggle('active');
  });
  navbarHamburger.addEventListener('click', function () {
    navbarHamburger.getElementsByClassName('hamburger')[0].classList.toggle('is-active');
    navBorder[1].classList.toggle('active');
  });

  const searchbtn = document.getElementById('search')!;
  const navMenu = document.querySelectorAll('.nav-menu')!;
  const navSearch = document.getElementById('nav-search')!;
  searchbtn.addEventListener('click', function () {
    navMenu[0].classList.toggle('active');
    navSearch.classList.toggle('active');
    this.classList.toggle('active');
    suggestionBox.classList.remove('active');
  });

  document.getElementById('listenLive')!.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    document.getElementById('popup')!.classList.toggle('active');
  });
  document.getElementById('listenLiveMobi')!.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    document.getElementById('popup')!.classList.toggle('active');
  });
  window.addEventListener('click', function () {
    document.getElementById('popup')!.classList.remove('active');
  });
  // on scroll
  window.addEventListener('scroll', function () {
    if (window.scrollY > 20) {
      document.querySelectorAll('.navbar')[0].classList.add('onscroll');
      document.querySelectorAll('.navbar-borderline')[0].classList.add('onscroll');
      document.querySelectorAll('.nav-menu')[0].classList.add('onscroll');
      document.querySelectorAll('.nav-logo-img')[0].classList.add('onscroll');
      document.querySelectorAll('#nav-hamburger')[0].classList.add('onscroll');
      document.querySelectorAll('#nav-search')[0].classList.add('onscroll');
    } else {
      document.querySelectorAll('.navbar')[0].classList.remove('onscroll');
      document.querySelectorAll('.navbar-borderline')[0].classList.remove('onscroll');
      document.querySelectorAll('.nav-menu')[0].classList.remove('onscroll');
      document.querySelectorAll('.nav-logo-img')[0].classList.remove('onscroll');
      document.querySelectorAll('#nav-hamburger')[0].classList.remove('onscroll');
      document.querySelectorAll('#nav-search')[0].classList.remove('onscroll');
    }
  });

  //freqs
  const frequencies = [
    {
      city: 'Świdnica',
      freq: '98.1',
    },
    {
      city: 'Kłodzko',
      freq: '97.1',
    },
    {
      city: 'Wołów',
      freq: '99.6',
    },
    {
      city: 'Milicz',
      freq: '88.5',
    },
    {
      city: 'Góra Igliczna',
      freq: '107.2',
    },
    {
      city: 'Kudowa Zdrój',
      freq: '88.7',
    },
    {
      city: 'Brzeg',
      freq: '94.0',
    },
    {
      city: 'Góra',
      freq: '90.7',
    },
    {
      city: 'Wrocław',
      freq: '92.0',
    },
  ];

  const freq = document.getElementById('freq');
  const freqMobi = document.getElementById('freqMobi');
  let i = 0;
  function switchFreqs() {
    if (freq && freqMobi) {
      freq.innerHTML = frequencies[i].city + ' ' + frequencies[i].freq + ' FM';
      freqMobi.innerHTML = frequencies[i].city + ' ' + frequencies[i].freq + ' FM';
    }
    if (i == frequencies.length - 1) i = 0;
    i++;
  }
  setInterval(function () {
    switchFreqs();
  }, 2500);
});
